import React, { Component }  from 'react';
import { IntlProvider, addLocaleData } from 'react-intl';
import {setLanguage} from '../modules/tran';
import { connect } from 'react-redux';

import localEn from '../../../i18n/en_US';
import localZh from '../../../i18n/zh_CN.js';

//en_us和en的对应关系
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';


var localeData = {
  en: Object.assign({}, localEn),
  zh: Object.assign({}, localZh)
}
var supportedLang = ['en', 'zh'];

//需要本地化的语言
addLocaleData([...en, ...zh]);
//获取本地语言
const uaLang = (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage;

//可设置语言类型
const languageWithoutRegionCode = uaLang.toLowerCase().split(/[_-]+/)[0];
var cachedLang = localStorage.getItem('lang');

//const languageWithoutRegionCode = 'en';
//messages data.json 里对应的 语言文本

var initLang = cachedLang || languageWithoutRegionCode || 'zh';

function isSupportedLang(l) {
  return supportedLang.indexOf(l) >= 0;
}

if (!isSupportedLang(initLang)) {
  initLang = 'zh';
}

const mapActionCreators = {
  setLanguage,
};

const mapStateToProps = (state) => ({
  lang: state.tran.lang,
  mapping: state.tran.mapping
});

class Translate extends Component {

  messages = localeData[initLang];
  state = {
    serverStringLoaded: false
  }

  componentWillMount = () => {
    this.messages = localeData[initLang];
    localStorage.setItem('lang', initLang);
    if(initLang !== this.props.lang){
      this.props.setLanguage(initLang);
    }
  }

  componentDidMount = () => {

  }

  componentWillReceiveProps = (newProps)=> {
    if (this.props.lang !== newProps.lang && isSupportedLang(newProps.lang)) {
      this.messages = localeData[newProps.lang];
      localStorage.setItem('lang', newProps.lang);
    }
  }

  render() {
    return (
      <IntlProvider locale={ this.props.lang } messages={ this.messages } key={this.props.lang+this.state.serverStringLoaded}>
        {this.props.children}
      </IntlProvider>
    );
  }
}

export default connect(mapStateToProps, mapActionCreators)(Translate);

/*  通过代码调用i18n
 1.导入 injectIntl
 import { injectIntl, FormattedMessage } from 'react-intl';

 2.在组件中注入
 export default connect(mapStateToProps,mapActionCreators)(injectIntl(App))

 我在项目中用到了Redux，注入的时候应该向上面那样，如果你没有用Redux ，只需要 export defuault injectIntl(App)

 3.使用 intl 对象
 我们通过第二步的注入，现在在我们在 组件的 props 上会得到一个 intl 对象，它提供的方法和咱们上边介绍的组件基本相对应，这时候我们想要显示字符串，可以使用formatMessage 方法：

 const {intl} = this.props;
 　　
 let tmp = intl.formatMessage({id: 'intl.name'},{name: 'joe'});
 */
